import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { DataService } from '../../Services/DataSharingService';
import { HeaderService } from '../../Services/HeaderService';

@Component({
	selector: 'app-mega-menu',
	templateUrl: './mega-menu.component.html',
	styleUrls: ['./mega-menu.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MegaMenuComponent implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Mega Menu');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}

	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}

	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'mega-menu') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('mega-menu');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/mega-menu/mega-menu.component.ts